import * as R from 'ramda'
import i18n from '@/locales'
import { arrayToObj } from '@/utils/utils'

// 用于查询消费趋势
export const TIME_SIZE = {
  month: 'day', // 近一个月的时间粒度为1天
  year: 'month', // 近一年的时间密粒度1个月
  last_month: 'day',
  quarter: 'month',
  last_quarter: 'month',
  half_year: 'month',
}

export const DURATION = {
  month: i18n.t('bill.text_46'),
  day: i18n.t('bill.text_3'),
  hour: i18n.t('bill.text_4'),
  minute: i18n.t('bill.text_5'),
  usage: i18n.t('bill.duration.usage'),
}

export const CHARGE_TYPE = {
  postpaid: i18n.t('billingType.postpaid'),
  prepaid: i18n.t('billingType.prepaid'),
  amortized: i18n.t('bill.bill_prepaid_amortizing'),
  bandwidth: i18n.t('bill.text_8'),
  traffic: i18n.t('bill.text_9'),
}

export const PROJECT_TYPE = {
  syncpolicy: i18n.t('projectType.syncpolicy'),
  default: i18n.t('projectType.default'),
  sharing: i18n.t('projectType.sharing'),
}

export const CLOUD_ENVS = [
  {
    item_id: 'all',
    item_name: i18n.t('bill.text_318'),
  },
  {
    item_id: 'onpremise',
    item_name: i18n.t('cloud_env.onpremise'),
  },
  {
    item_id: 'private',
    item_name: i18n.t('cloud_env.private'),
  },
  {
    item_id: 'public',
    item_name: i18n.t('cloud_env.public'),
  },
]

export const ACCOUNTS = [{
  item_id: 'all',
  item_name: i18n.t('bill.text_10'),
}]

export const SUBACCOUNTS = [{
  item_id: 'all',
  item_name: i18n.t('bill.all_subaccounts'),
}]

export const REGIONS = [{
  item_id: 'all',
  item_name: i18n.t('bill.text_11'),
}]

export const PLATFORMS = [{
  item_id: 'all',
  item_name: i18n.t('bill.text_12'),
}]

export const PROJECTS = [{
  item_id: 'all',
  item_name: i18n.t('bill.text_13', [i18n.t('dictionary.project')]),
}]

export const CHARGE_TYPES = [
  {
    item_id: 'prepaid',
    item_name: CHARGE_TYPE.prepaid,
  },
  {
    item_id: 'postpaid',
    item_name: CHARGE_TYPE.postpaid,
  },
  {
    item_id: 'amortized',
    item_name: CHARGE_TYPE.amortized,
  },
]

export const DIC = {
  'rotate - local': i18n.t('bill.text_15'),
  'rotate - rbd': i18n.t('bill.text_16'),
  'ssd - rbd': i18n.t('bill.text_17'),
  'outer - outflow': i18n.t('bill.text_18'),
  'outer - inflow': i18n.t('bill.text_19'),
  'inner - outflow': i18n.t('bill.text_20'),
  'inner - inflow': i18n.t('bill.text_21'),
  'outer - out_bandwidth': i18n.t('bill.text_22'),
  'outer - in_bandwidth': i18n.t('bill.text_23'),
  'inner - out_bandwidth': i18n.t('bill.text_24'),
  'inner - in_bandwidth': i18n.t('bill.text_25'),
}

export const RATE_UNIT = {
  '1entire': i18n.t('bill.text_26'),
  '1card': i18n.t('bill.text_27'),
  '1core': 1 + i18n.t('bill.text_28'),
  '1GB': '1GB',
  '1Mbps': '1Mbps',
}

export const RuleTypes = [
  { key: 'EIP_UNUSED', label: i18n.t('suggestsyRuleTypes.EIP_UNUSED') },
  { key: 'DISK_UNUSED', label: i18n.t('suggestsyRuleTypes.DISK_UNUSED') },
  { key: 'LB_UNUSED', label: i18n.t('suggestsyRuleTypes.LB_UNUSED') },
  { key: 'DOWN_SIZE', label: i18n.t('suggestsyRuleTypes.DOWN_SIZE') },
  { key: 'UP_SIZE', label: i18n.t('suggestsyRuleTypes.UP_SIZE') },
  { key: 'SCALE_DOWN', label: i18n.t('suggestsyRuleTypes.SCALE_DOWN') },
  { key: 'TIMING_OPEN_SERVER', label: i18n.t('suggestsyRuleTypes.TIMING_OPEN_SERVER') },
  { key: 'SCALING_SERVER', label: i18n.t('suggestsyRuleTypes.SCALING_SERVER') },
  { key: 'EXPIRE_SERVER_SKU', label: i18n.t('suggestsyRuleTypes.EXPIRE_SERVER_SKU') },
  { key: 'RDS_UNREASONABLE', label: i18n.t('suggestsyRuleTypes.RDS_UNREASONABLE') },
  { key: 'OSS_UNREASONABLE', label: i18n.t('suggestsyRuleTypes.OSS_UNREASONABLE') },
  { key: 'REDIS_UNREASONABLE', label: i18n.t('suggestsyRuleTypes.REDIS_UNREASONABLE') },
  { key: 'SECGROUPRULEINSERVER_ALLIN', label: i18n.t('suggestsyRuleTypes.SECGROUPRULEINSERVER_ALLIN') },
  { key: 'SNAPSHOT_UNUSED', label: i18n.t('suggestsyRuleTypes.SNAPSHOT_UNUSED') },
  { key: 'OSS_SEC_ACL', label: i18n.t('suggestsyRuleTypes.OSS_SEC_ACL') },
  { key: 'CLOUDACCOUNT_AMOUNT_DAILY', label: i18n.t('suggestsyRuleTypes.CLOUDACCOUNT_AMOUNT_DAILY') },
  { key: 'CLOUDACCOUNT_AMOUNT_MONTH', label: i18n.t('suggestsyRuleTypes.CLOUDACCOUNT_AMOUNT_MONTH') },
  { key: 'TIMING_SERVER', label: i18n.t('suggestsyRuleTypes.TIMING_SERVER') },
  { key: 'UPGRADE_PREPAID', label: i18n.t('suggestsyRuleTypes.upgrade_prepaid') },
  { key: 'DOWN_SIZE_BY_MEM', label: i18n.t('suggestsyRuleTypes.DOWN_SIZE_BY_MEM') },
]

export const Suggestion = [
  { key: 'EIP_UNUSED', label: i18n.t('suggestsySuggestion.EIP_UNUSED') },
  { key: 'DISK_UNUSED', label: i18n.t('suggestsySuggestion.DISK_UNUSED') },
  { key: 'LB_UNUSED', label: i18n.t('suggestsySuggestion.LB_UNUSED') },
  { key: 'DOWN_SIZE', label: i18n.t('suggestsySuggestion.DOWN_SIZE') },
  { key: 'UP_SIZE', label: i18n.t('suggestsySuggestion.UP_SIZE') },
  { key: 'SCALE_DOWN', label: i18n.t('suggestsySuggestion.SCALE_DOWN') },
  { key: 'TIMING_OPEN_SERVER', label: i18n.t('suggestsySuggestion.TIMING_OPEN_SERVER') },
  { key: 'SCALING_SERVER', label: i18n.t('suggestsySuggestion.SCALING_SERVER') },
  { key: 'EXPIRE_SERVER_SKU', label: i18n.t('suggestsySuggestion.EXPIRE_SERVER_SKU') },
  { key: 'RDS_UNREASONABLE', label: i18n.t('suggestsySuggestion.RDS_UNREASONABLE') },
  { key: 'OSS_UNREASONABLE', label: i18n.t('suggestsySuggestion.OSS_UNREASONABLE') },
  { key: 'REDIS_UNREASONABLE', label: i18n.t('suggestsySuggestion.REDIS_UNREASONABLE') },
  { key: 'SECGROUPRULEINSERVER_ALLIN', label: i18n.t('suggestsySuggestion.SECGROUPRULEINSERVER_ALLIN') },
  { key: 'SNAPSHOT_UNUSED', label: i18n.t('suggestsySuggestion.SNAPSHOT_UNUSED') },
  { key: 'OSS_SEC_ACL', label: i18n.t('suggestsySuggestion.OSS_SEC_ACL') },
  { key: 'CLOUDACCOUNT_AMOUNT_DAILY', label: i18n.t('suggestsySuggestion.CLOUDACCOUNT_AMOUNT_DAILY') },
  { key: 'CLOUDACCOUNT_AMOUNT_MONTH', label: i18n.t('suggestsySuggestion.CLOUDACCOUNT_AMOUNT_MONTH') },
  { key: 'TIMING_SERVER', label: i18n.t('suggestsySuggestion.TIMING_SERVER') },
  { key: 'UPGRADE_PREPAID', label: i18n.t('bill.text_suggest_upgrade_prepaid') },
  { key: 'DOWN_SIZE_BY_MEM', label: i18n.t('suggestsyRuleTypes.DOWN_SIZE_BY_MEM') },
]

export const RuleTypeMap = (function () {
  let rtMap = null
  if (!rtMap) {
    rtMap = {}
    RuleTypes.forEach((v) => {
      rtMap[v.key] = v.key
    })
  }
  return rtMap
})()

export const DOMAINS = [{
  item_id: 'all',
  item_name: i18n.t('bill.text_13', [i18n.t('dictionary.domain')]),
}]

export const CLOUDPROVIDERS = [{
  item_id: 'all',
  item_name: i18n.t('bill.text_13', [i18n.t('dictionary.cloudprovider')]),
}]

export const RESOURCES = [{
  item_id: 'all',
  item_name: i18n.t('bill.text_32'),
}]

export const USAGES = [{
  item_id: 'all',
  item_name: i18n.t('bill.text_33'),
}]

export const SPECS = [{
  item_id: 'all',
  item_name: i18n.t('bill.all_product'),
}]

export const FINANCIAL_UNITS = [
  { item_id: 'all', item_name: i18n.t('bill.all_financial_unit') },
]

export const PRECISION = 6

export const LOOKBACK_DAYS = [
  { key: 7, value: i18n.t('bill.ri_lookback_days_7') },
  { key: 30, value: i18n.t('bill.ri_lookback_days_30') },
  { key: 60, value: i18n.t('bill.ri_lookback_days_60') },
]
export const LOOKBACK_DAYS_MAP = arrayToObj(LOOKBACK_DAYS, 'key')

export const RESERVATION_YEARS = [
  { key: 1, value: i18n.t('bill.ri_reservation_years_1') },
  { key: 3, value: i18n.t('bill.ri_reservation_years_3') },
]
export const RESERVATION_YEARS_MAP = arrayToObj(RESERVATION_YEARS, 'key')

export const PAYMENT_OPTIONS = [
  { key: 'all_upfront', value: i18n.t('bill.ri_payment_all_upfront') },
  { key: 'partial_upfront', value: i18n.t('bill.ri_payment_partial_upfront') },
  { key: 'no_upfront', value: i18n.t('bill.ri_payment_no_upfront') },
]
export const PAYMENT_OPTIONS_MAP = arrayToObj(PAYMENT_OPTIONS, 'key')

export const OFFERING_CLASS = [
  { key: 'standard', value: i18n.t('bill.ri_payment_standard') },
  { key: 'convertible', value: i18n.t('bill.ri_payment_convertible') },
]
export const OFFERING_CLASS_MAP = arrayToObj(OFFERING_CLASS, 'key')

export const CURRENCYS = [
  { key: 'CNY', value: i18n.t('bill.budget_currency_cny') },
  { key: 'USD', value: i18n.t('bill.budget_currency_usd') },
]
export const CURRENCYS_MAP = arrayToObj(CURRENCYS, 'key')

export const CURRENCYS_RATE_LIST = [
  { src: 'USD', srcLabel: i18n.t('bill.budget_currency_usd'), dest: 'CNY', destLabel: i18n.t('bill.budget_currency_cny'), rate: 6.3967 },
  { src: 'USD', srcLabel: i18n.t('bill.budget_currency_usd'), dest: 'BRL', destLabel: i18n.t('bill.budget_currency_brl'), rate: 5.1165 },
  { src: 'USD', srcLabel: i18n.t('bill.budget_currency_usd'), dest: 'EUR', destLabel: i18n.t('bill.budget_currency_eur'), rate: 0.9308 },
  { src: 'BRL', srcLabel: i18n.t('bill.budget_currency_brl'), dest: 'CNY', destLabel: i18n.t('bill.budget_currency_cny'), rate: 1.2502 },
  { src: 'EUR', srcLabel: i18n.t('bill.budget_currency_eur'), dest: 'BRL', destLabel: i18n.t('bill.budget_currency_brl'), rate: 5.47 },
  { src: 'EUR', srcLabel: i18n.t('bill.budget_currency_eur'), dest: 'CNY', destLabel: i18n.t('bill.budget_currency_cny'), rate: 7.76 },
]

export const ANALYSIS_GROUP_RATE_LIST = [
  { key: 'brand', value: i18n.t('bill.text_81') },
  { key: 'account', value: i18n.t('bill.text_60') },
  { key: 'owner_name', value: i18n.t('bill.owner_account') },
  { key: 'linked_name', value: i18n.t('bill.linked_account') },
  { key: 'cloudprovider_name', value: i18n.t('bill.text_311') },
  { key: 'region', value: i18n.t('bill.text_83') },
  { key: 'charge_type', value: i18n.t('bill.text_84') },
  { key: 'domain', t: 'dictionary.domain' },
  { key: 'project', t: 'dictionary.project' },
  { key: 'external_project_name', value: i18n.t('bill.external_project') },
  { key: 'resource_type', value: i18n.t('bill.text_73') },
  { key: 'origin_res_type', value: i18n.t('bill.cloud_res_type') },
  { key: 'usage_type', value: i18n.t('bill.usage_type') },
  { key: 'tag', value: i18n.t('bill.text_79') },
  { key: 'instance_tag', t: 'dictionary.instance_tag' },
  { key: 'project_tag', t: 'dictionary.project_tag' },
  { key: 'spec', value: i18n.t('meter.bill_impact_factor') },
  { key: 'financial_unit', value: i18n.t('bill.financial_unit') },
  { key: 'product_type', value: i18n.t('bill.product_type') },
]

export const ANALYSIS_GROUPT_TYPE_MAP = arrayToObj(ANALYSIS_GROUP_RATE_LIST, 'key')

export const PREDICT_ANALYSIS_GROUP_RATE_LIST = [
  { key: 'brand', value: i18n.t('bill.text_81') },
  { key: 'account', value: i18n.t('bill.text_60') },
  { key: 'project', t: 'dictionary.project' },
  { key: 'origin_res_type', value: i18n.t('bill.cloud_res_type') },
  { key: 'charge_type', value: i18n.t('bill.text_84') },
]
export const PREDICT_ANALYSIS_GROUPT_TYPE_MAP = arrayToObj(PREDICT_ANALYSIS_GROUP_RATE_LIST, 'key')

export const ANALYSIS_SPLIT_OPTS = [
  { key: 'colon', value: ':', label: i18n.t('bill_splits_map.colon') },
  { key: 'semicolon', value: ';', label: i18n.t('bill_splits_map.semicolon') },
  { key: 'comma', value: ',', label: i18n.t('bill_splits_map.comma') },
  { key: 'space', value: ' ', label: i18n.t('bill_splits_map.space') },
]

export const ANALYSIS_SPLITS_MAP = arrayToObj(ANALYSIS_SPLIT_OPTS, 'key')

export const SUGGEST_RULE_TYPES = [
  { key: 1, label: i18n.t('meter.suggest_rule_type.1') },
  { key: 2, label: i18n.t('meter.suggest_rule_type.2') },
  { key: 3, label: i18n.t('meter.suggest_rule_type.3') },
  { key: 4, label: i18n.t('meter.suggest_rule_type.4') },
  { key: 5, label: i18n.t('meter.suggest_rule_type.5') },
]

export const SUGGEST_RULE_RESOURCE_TYPES = [
  { key: 'disk', label: i18n.t('meter.suggest_rule_resource_type.disk') },
  { key: 'snapshot', label: i18n.t('meter.suggest_rule_resource_type.snapshot') },
  { key: 'eip', label: i18n.t('meter.suggest_rule_resource_type.eip') },
  { key: 'loadbalancer', label: i18n.t('meter.suggest_rule_resource_type.loadbalancer') },
  { key: 'server', label: i18n.t('meter.suggest_rule_resource_type.server') },
  { key: 'elasticcache', label: i18n.t('meter.suggest_rule_resource_type.elasticcache') },
  { key: 'dbinstance', label: i18n.t('meter.suggest_rule_resource_type.dbinstance') },
  { key: 'bucket', label: i18n.t('meter.suggest_rule_resource_type.bucket') },
  { key: 'cloudaccount_amount_daily', label: i18n.t('meter.suggest_rule_resource_type.cloudaccount_amount_daily') },
  { key: 'cloudaccount_amount_month', label: i18n.t('meter.suggest_rule_resource_type.cloudaccount_amount_month') },
]

export const SUGGEST_RULE_RESOURCE_TYPES_MAP = arrayToObj(SUGGEST_RULE_RESOURCE_TYPES, 'key')

export const SUGGEST_RULE_RESOURCE_RULE_MAP = {
  1: [SUGGEST_RULE_RESOURCE_TYPES_MAP.disk, SUGGEST_RULE_RESOURCE_TYPES_MAP.snapshot, SUGGEST_RULE_RESOURCE_TYPES_MAP.eip, SUGGEST_RULE_RESOURCE_TYPES_MAP.loadbalancer],
  2: [SUGGEST_RULE_RESOURCE_TYPES_MAP.server, SUGGEST_RULE_RESOURCE_TYPES_MAP.elasticcache, SUGGEST_RULE_RESOURCE_TYPES_MAP.dbinstance, SUGGEST_RULE_RESOURCE_TYPES_MAP.bucket],
  3: [SUGGEST_RULE_RESOURCE_TYPES_MAP.server, SUGGEST_RULE_RESOURCE_TYPES_MAP.dbinstance, SUGGEST_RULE_RESOURCE_TYPES_MAP.elasticcache],
  4: [SUGGEST_RULE_RESOURCE_TYPES_MAP.bucket],
  5: [SUGGEST_RULE_RESOURCE_TYPES_MAP.cloudaccount_amount_daily, SUGGEST_RULE_RESOURCE_TYPES_MAP.cloudaccount_amount_month],
}

export const SUGGEST_RULE_TIME_FROM_UNIT = [
  { key: 'm', label: i18n.t('bill.text_5') },
  { key: 'h', label: i18n.t('bill.text_4') },
  { key: 'd', label: i18n.t('bill.text_3') },
  { key: 'M', label: i18n.t('bill.text_46') },
  { key: 'y', label: i18n.t('bill.text_48') },
]

export const SUGGEST_RULE_METRIC = [
  {
    resource_type: 'server',
    metrics: [
      {
        name: 'cpu',
        label: i18n.t('compute.text_523'),
        seleteItem: 'usage_active',
        fromItem: 'vm_cpu',
        fromItemLabel: i18n.t('meter.suggest_rule.fromItem.cpu'),
        unit: '%',
        transfer: 1,
      },
      {
        name: 'mem',
        label: i18n.t('compute.text_518'),
        seleteItem: 'used_percent',
        fromItem: 'vm_mem',
        fromItemLabel: i18n.t('meter.suggest_rule.fromItem.mem'),
        unit: '%',
        transfer: 1,
      },
      {
        name: 'disk',
        label: i18n.t('compute.text_533'),
        seleteItem: 'used_percent',
        groupBy: ['device', 'path', 'fstype'],
        fromItem: 'vm_disk',
        fromItemLabel: i18n.t('meter.suggest_rule.fromItem.disk'),
        unit: '%',
        transfer: 1,
      },
    ],
  },
  {
    resource_type: 'dbinstance',
    metrics: [
      {
        name: 'cpu',
        label: i18n.t('db.text_11'),
        seleteItem: 'usage_active',
        fromItem: 'rds_cpu',
        fromItemLabel: i18n.t('meter.suggest_rule.fromItem.cpu'),
        as: i18n.t('db.text_11'),
        unit: '%',
        transfer: 1,
      },
      {
        name: 'mem',
        label: i18n.t('db.text_12'),
        seleteItem: 'used_percent',
        fromItem: 'rds_mem',
        fromItemLabel: i18n.t('meter.suggest_rule.fromItem.mem'),
        as: i18n.t('db.text_12'),
        unit: '%',
        transfer: 1,
      },
    ],
  },
  {
    resource_type: 'elasticcache',
    metrics: [
      // {
      //   name: 'cpu',
      //   label: i18n.t('db.text_11'),
      //   seleteItem: 'usage_active',
      //   fromItem: 'dcs_cpu',
      //   fromItemLabel: i18n.t('meter.suggest_rule.fromItem.cpu'),
      //   as: i18n.t('db.text_11'),
      //   unit: '%',
      //   transfer: 1,
      // },
      {
        name: 'mem',
        label: i18n.t('db.text_12'),
        seleteItem: 'used_percent',
        fromItem: 'dcs_mem',
        fromItemLabel: i18n.t('meter.suggest_rule.fromItem.mem'),
        as: i18n.t('db.text_12'),
        unit: '%',
        transfer: 1,
      },
    ],
  },
  {
    resource_type: 'bucket',
    metrics: [
      {
        name: 'req_count',
        label: i18n.t('db.text_11'),
        seleteItem: 'req_count',
        seleteItemLabel: i18n.t('monitor.text_118'),
        fromItem: 'oss_req',
        fromItemLabel: i18n.t('meter.suggest_rule.fromItem.oss_req'),
        as: i18n.t('db.text_11'),
        unit: '',
        transfer: 1,
      },
    ],
  },
]

export const SUGGEST_RULE_METRIC_MAP = arrayToObj(SUGGEST_RULE_METRIC, 'resource_type')

export const getSuggestRuleConfig = ({ type: originType, resource_type, time_from, threshold, eval_type, reduce_type = 'avg', measurement, field, adjust_ratio, rate }) => {
  const ret = {
    name: '',
    desc: '',
    rule: '',
    method: '',
  }
  const data = {}
  if (time_from) {
    data.time_from = Number(time_from.replace(/\D+/, ''))
    data.time_from_unit = time_from.replace(/\d+/, '')
    data.time_from_unit_text = arrayToObj(SUGGEST_RULE_TIME_FROM_UNIT, 'key')[data.time_from_unit].label
  }
  let type = originType
  if (R.is(String, originType)) {
    if (originType.includes('UP_DOWN_')) {
      type = 2
    } else if (originType.includes('_UNUSED')) {
      type = 1
    } else if (originType === 'UPGRADE_PREPAID') {
      type = 3
    } else if (originType === 'OSS_SEC_ACL') {
      type = 4
    } else if (originType.includes('CLOUDACCOUNT_AMOUNT_')) {
      type = 5
    }
  }
  if (type === SUGGEST_RULE_TYPES[0].key) {
    // 闲置资源
    if (['disk', 'snapshot', 'eip', 'loadbalancer'].includes(resource_type)) {
      ret.name = i18n.t(`meter.suggest_rule.name.${resource_type}`)
      ret.desc = i18n.t(`meter.suggest_rule.desc.${resource_type}`)
      ret.rule = i18n.t(`meter.suggest_rule.rule.${resource_type}`, [data.time_from, data.time_from_unit_text])
      ret.method = i18n.t('bill.text_167')
      let t = resource_type
      if (resource_type === 'loadbalancer') t = 'lb'
      if (resource_type === 'dbinstance') t = 'rds'
      if (resource_type === 'elasticcache') t = 'redis'
      ret.type = `${t.toUpperCase()}_UNUSED`
      // ret.accuracyInfo = 'x'
    }
  } else if (type === SUGGEST_RULE_TYPES[1].key) {
    // 升降配
    ret.name = i18n.t(eval_type === '>' ? 'meter.upgrade_resource' : 'meter.downgrade_resource', [SUGGEST_RULE_RESOURCE_TYPES_MAP[resource_type].label])
    const metric = SUGGEST_RULE_METRIC.filter(item => item.resource_type === resource_type)
    if (metric.length) {
      const target = metric[0].metrics.filter(item => item.fromItem === measurement && item.seleteItem === field)
      if (target.length) {
        ret.rule = `${i18n.t(`meter.suggestrule.metric.${measurement}.${field}`, [i18n.t(`monitor.${reduce_type}`)])} ${eval_type} ${threshold}${resource_type === 'bucket' ? '' : '%'}`
      }
    }
    let t = resource_type
    if (resource_type === 'loadbalancer') t = 'lb'
    if (resource_type === 'dbinstance') t = 'rds'
    if (resource_type === 'elasticcache') t = 'redis'
    ret.type = `UP_DOWN_${t.toUpperCase()}`
    if (adjust_ratio === 100) {
      ret.method = i18n.t(`meter.${resource_type === 'bucket' ? 'bucket_' : ''}upgrade_100`)
    }
    if (adjust_ratio === -50) {
      ret.method = i18n.t(`meter.${resource_type === 'bucket' ? 'bucket_' : ''}downgrade_50`)
    }
    if (adjust_ratio === -100) {
      ret.method = i18n.t(`meter.${resource_type === 'bucket' ? 'bucket_' : ''}downgrade_100`)
    }
    if (adjust_ratio === -99 && resource_type === 'bucket') {
      ret.method = i18n.t('meter.bucket_downgrade_99')
    }
    // ret.accuracyInfo = 'x'
  } else if (type === SUGGEST_RULE_TYPES[2].key) {
    // 转换为包年包月
    ret.name = i18n.t(`meter.suggest_rule.name.${resource_type}1`)
    ret.desc = i18n.t(`meter.suggest_rule.desc.${resource_type}`)
    ret.rule = i18n.t('meter.suggest_rule.rule.upgrade_resource', [data.time_from, data.time_from_unit_text, i18n.t(`meter.suggest_rule_resource_type.${resource_type}`)])
    ret.method = i18n.t('meter.suggest_rule.method.prepaid')
    ret.type = 'UPGRADE_PREPAID'
    // ret.accuracyInfo = 'x'
  } else if (type === SUGGEST_RULE_TYPES[3].key) {
    // 调整存储桶权限
    ret.name = i18n.t(`meter.suggest_rule.name.${resource_type}1`)
    ret.desc = i18n.t(`meter.suggest_rule.desc.${resource_type}1`)
    ret.rule = i18n.t('meter.suggest_rule.rule.bucket1', [data.time_from, data.time_from_unit_text])
    ret.method = i18n.t('meter.suggest_rule.method.bucket1')
    ret.type = 'OSS_SEC_ACL'
  } else if (type === SUGGEST_RULE_TYPES[4].key) {
    // 异常消费
    const res_type = resource_type === 'cloudaccount' ? originType.toLowerCase() : resource_type
    ret.name = i18n.t(`meter.suggest_rule.name.${res_type}`)
    ret.desc = i18n.t(`meter.suggest_rule.desc.${res_type}`)
    ret.rule = i18n.t(`meter.suggest_rule.rule.${res_type}`, [data.time_from, data.time_from_unit_text, (rate || 0) * 100])
    ret.method = i18n.t(`meter.suggest_rule.method.${res_type}`)
    ret.type = res_type.toUpperCase()
  }
  return ret
}
